import React, { useEffect, useState } from "react";
import Head from 'next/head'



const Trialook = () => {
    return (
        <>
		<Head>
          <script type="text/javascript" src="https://cdn.roomvo.com/static/scripts/b2b/orientbell.js" defer=""></script>
          <title>Trialook by Orientbell Tiles, Try Before You Buy | Tile Visualizer</title>
	      <meta name="title" content="Trialook by Orientbell Tiles, Try Before You Buy | Tile Visualizer"/>
          <meta name="description" content="Experience the magic of Orientbell's Trialook, Tile Visualizer. Explore & visualize stunning tile designs in various settings like bathrooms, kitchens, living rooms, and more."/>
       </Head>
      
        </>
    )
}
export default Trialook;
